import { changeView, uploadLogo } from '../../../../../../../redux/product/product.actions';
import { removeLogo, selectLogo } from '../../../../../../../redux/logo/logo.actions';
import { editColors } from '../../../../../../../redux/logo-editing/logo-editing.actions';
import { openCompanyArtFolder } from '../../../../../../../redux/company-art-folder/company-art-folder.actions';
export const makeDispatcher = () => (dispatch, props) => {
  const view = props.view.id;
  return {
    onLogoUpload: file => dispatch(uploadLogo(file, view)),
    onLogoDelete: id => dispatch(removeLogo(id)),
    onViewNameClick: () => dispatch(changeView(view)),
    onLogoEditColors: logo => {
      dispatch(selectLogo(logo.id));
      dispatch(editColors(logo));
    },
    onSelectLogoFromList: () => {
      dispatch(openCompanyArtFolder(view));
    }
  };
};